import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalBody } from 'reactstrap';
import { exitActionKiosk } from "../../../../store/actions";
import close from '../../../../images/close.svg';
import errorimg from '../../../../images/error.png';
import { IKIOSKModel } from "../../../../models/kioskModel";
import { Ilanguages } from "../../../../models/utilitiesModel";
import { getShowMessageTime } from "../../../../helpers/helpersIndex";
let setinterval;

const ErrormessageModal: React.FC = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation("translations");
    // const selectedArea: string = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel).selectedPage);
    const errorMessage: string = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.errorMessage) ;
    const language:string = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.language || Ilanguages.ENG ) ;
    const suspendErrorInitiate = () => {
        dispatch(exitActionKiosk());
        if (setinterval)
            clearTimeout(setinterval);
    }
    if (errorMessage) {
        setinterval = setTimeout(() => {
            suspendErrorInitiate();
        }, getShowMessageTime() * 1000);
    }
    return (
        <>
            {errorMessage && errorMessage !== '' &&
                <Modal isOpen={true} className="kiosk_error_modal">
                    <ModalBody>
                        <div className="errorMessage">
                            <div className="text-end pointer" onClick={suspendErrorInitiate}>
                                <img src={close} alt="" width="30" />
                            </div>
                            <img src={errorimg} alt="" />
                            {errorMessage === 'EM0' && <p>{t('errorMessage.EM1' + language)}<br /> {t('errorMessage.EM2' + language)}</p>}
                            {errorMessage !== 'EM0' && <p>{t('errorMessage.' + errorMessage + language) === 'errorMessage.' + errorMessage + language ? errorMessage : t('errorMessage.' + errorMessage + language)}</p>}
                        </div>
                    </ModalBody>
                </Modal>
            }
        </>
    )
}
export default React.memo(ErrormessageModal);